import { render, staticRenderFns } from "./register_验证码版本.vue?vue&type=template&id=eb4f623c&scoped=true"
import script from "./register_验证码版本.vue?vue&type=script&lang=js"
export * from "./register_验证码版本.vue?vue&type=script&lang=js"
import style0 from "./register_验证码版本.vue?vue&type=style&index=0&id=eb4f623c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb4f623c",
  null
  
)

export default component.exports